import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { APP_CONSTANTS as CONST } from '@app/app.constants';
import { Offers, PreviewOffer } from '../../../../../core/models/offers.model';
import { OffersService } from '../../../../../domain/services/offers.service';

@Component({
  selector: 'home-offer-card',
  templateUrl: './offer-card.component.html',
  styleUrls: ['./offer-card.component.scss'],
})
export class OfferCardComponent implements OnInit {
  @Input() typeOffer: string;
  @Input() selected: string;
  @Input() exampleOffers: boolean;
  @Input() offer: Offers;
  @Input() amount: string;
  @Input() previewOffer: PreviewOffer;
  @Input() offerSelected: number;
  @Output() previewOfferSelected$ = new EventEmitter<PreviewOffer>();
  @Output() offerSelected$ = new EventEmitter<string>();

  public seeLess: string = 'Ver menos';
  public seeLoanSummary: string = 'Ver plan de pagos';
  public buttonName: string = this.seeLoanSummary;
  public showLoanSummary: boolean = false;
  public installments: Array<string>;
  public totalCostWithTaxes: string;
  public totalCostNumber: number;
  public totalToPay: number;
  public CONST = CONST;
  public threeInstallments: string = 'Sin intereses, ni comisiones';
  public sixInstallments: string = 'A tu ritmo';
  public twelveInstallments: string = 'Despreocúpate de tu línea de crédito';
  public defaultText: string = 'A tu ritmo';

  constructor(private _offersService: OffersService) {}

  ngOnInit(): void {
    this._setValues();
    this._setTotalCosts();
    this.onSetTotalCostsToNumber();
  }

  private _setValues() {
    const offer: number = Number(this.typeOffer);
    this.totalCostWithTaxes = this._offersService.setTotalCostWithTaxes(
      this.previewOffer?.details.total_costs,
      this.previewOffer?.details.total_taxes
    );
    this.installments = Array(offer).fill('');
    if (this.typeOffer == this.selected) {
      this.showLoanSummary = true;
      this.buttonName = this.seeLess;
    }
  }

  private _setTotalCosts() {
    this.totalCostWithTaxes = this._offersService.setTotalCostWithTaxes(
      this.previewOffer?.details.total_costs,
      this.previewOffer?.details.total_taxes
    );

    this.totalToPay = Number(this.totalCostWithTaxes) + Number(this.amount);
  }

  public onShowLoanSummary() {
    this.buttonName == this.seeLoanSummary
      ? (this.buttonName = this.seeLess)
      : (this.buttonName = this.seeLoanSummary);

    this.showLoanSummary == false ? (this.showLoanSummary = true) : (this.showLoanSummary = false);
  }

  public selectOffer(typeOffer: string, previewOffer: PreviewOffer) {
    this.offerSelected$.emit(typeOffer);
    this.previewOfferSelected$.emit(previewOffer);
  }

  public onSetTotalCostsToNumber(): number {
    this.totalCostNumber = Number(this.previewOffer.details.total_costs);
    return this.totalCostNumber;
  }
}
